export const BASE_URL = process.env.REACT_APP_API_URL
export const STRIPE_PUBLIC_TEST_KEY = process.env.REACT_APP_STRIPE_PUBLIC_TEST_KEY
export const publishKey = process.env.REACT_APP_PUB_KEY
export const subscribeKey = process.env.REACT_APP_SUB_KEY